import FaqContainer from "../components/faqContainers";

function Faqs() {
    return (
        <FaqContainer />
    )
}

export default Faqs;